module.exports = __webpack_public_path__ + "static/img/kva.48185f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/kva.png
// module id = 493
// module chunks = 1